import { render, staticRenderFns } from "./contentElementApopedia.vue?vue&type=template&id=d28f12d0&scoped=true"
import script from "./contentElementApopedia.vue?vue&type=script&lang=js"
export * from "./contentElementApopedia.vue?vue&type=script&lang=js"
import style0 from "./contentElementApopedia.vue?vue&type=style&index=0&id=d28f12d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28f12d0",
  null
  
)

export default component.exports